export const longDateFormat = date => {
    return date.substring(date.indexOf(" "), date.length);
}